// src/app/app.config.ts
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { routes } from './app-routing'; // Import your routes
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNgIdleKeepalive } from '@ng-idle/keepalive';
import { tokenInterceptor } from './shared/interceptors/token.interceptor';
import { TokenService } from './shared/services/token.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { LicenseManager } from 'ag-grid-enterprise';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';


LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-067663}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ernst_&_Young_LLP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EY_Virtual_App_Store}_only_for_{7}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{EY_Virtual_App_Store}_need_to_be_licensed___{EY_Virtual_App_Store}_has_been_granted_a_Deployment_License_Add-on_for_{7}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{19_December_2025}____[v3]_[01]_MTc2NjEwMjQwMDAwMA==c004e328da2dfc4bf4e0c7661a41b4cc');

export function tokenRefreshFactory(tokenService: TokenService) {
  return () => tokenService.acquireRefreshToken().subscribe();
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes), // Set up routing
    provideNgIdleKeepalive(),
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      BrowserAnimationsModule
    ), // Import BrowserModule for browser-specific features
    importProvidersFrom(), // Ensure BrowserModule is imported for browser-specific features
    {
      provide: APP_INITIALIZER,
      useFactory: tokenRefreshFactory,
      deps: [TokenService],
      multi: true
    },
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    ),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          cssLayer: false
        }
      }
    }),
  ],
};
